// Datos legales de FullStop. RELLENA con tus datos reales antes de vender.
export const legal = {
  brand: "FullStop",
  legalName: "Eduardo Sánchez Velayos",
  nif: "43208236E",
  address: "Carrer de Prat de la Riba 11",
  email: "edusanchez98.98@gmail.com",
  domain: "aurorapods.beautyos.es",
  returnDays: 30,
};
